import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, createContext, useContext, useCallback } from 'react';
import styled from 'styled-components';
import Header from './header.js';
import Copy from './copy.js';
import CDNIllustration from './cdn-illustration.js';
import { StandardCard } from './standard-card.js';
const WizardFlowContext = createContext({});
export const ChildContainer = styled.div.withConfig({ displayName: "brc-ChildContainer", componentId: "brc-1yyalt6" }) ``;
export const Image = styled(CDNIllustration).withConfig({ displayName: "brc-Image", componentId: "brc-3vvljv" }) `
  max-width: 192px;
  justify-self: center;
  @media (${({ theme }) => theme.forLargerThanPhone}) {
    width: 192px;
  }
`;
export const Container = styled.div.withConfig({ displayName: "brc-Container", componentId: "brc-72bxpj" }) `
  display: grid;
  grid-template-columns: auto;
  grid-auto-rows: auto;

  ${ChildContainer} {
    grid-column: span 2;
    grid-row: 2;
  }

  @media (${({ theme }) => theme.forLargerThanPhone}) {
    grid-template-columns: 1fr 2fr;
    grid-auto-rows: auto;
    ${Image} {
      grid-row: span 2;
    }

    ${ChildContainer} {
      grid-column: initial;
      grid-row: initial;
    }
  }
`;
const StyledCopy = styled(Copy).withConfig({ displayName: "brc-StyledCopy", componentId: "brc-rr1418" }) `
  /* styling for the colored bar above the question steps label */
  &::before {
    content: '';
    background: ${({ stepColor, theme }) => stepColor || theme.bubbleBlue400};
    display: block;
    width: 88px;
    height: 8px;
    border-radius: 4px;
    margin-bottom: 16px;
  }
`;
export const InnerContainer = styled.div.withConfig({ displayName: "brc-InnerContainer", componentId: "brc-1pm2nll" }) `
  display: grid;
  grid-gap: 16px;
`;
export const WizardFlowProvider = ({ children }) => {
    const childrenArray = React.Children.toArray(children);
    const [currentStep, setCurrentStep] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const incrementStep = useCallback(() => setCurrentStep(currentStep + 1), [currentStep]);
    const decrementStep = useCallback(() => setCurrentStep(currentStep - 1), [currentStep]);
    const values = {
        currentStep: currentStep + 1,
        totalSteps: childrenArray.length,
        incrementStep,
        decrementStep,
        isLoading,
        setIsLoading,
    };
    return _jsx(WizardFlowContext.Provider, Object.assign({ value: values }, { children: childrenArray[currentStep] }));
};
export const useWizardFlow = () => {
    const { currentStep, totalSteps, incrementStep, decrementStep, isLoading, setIsLoading } = useContext(WizardFlowContext);
    return { currentStep, totalSteps, incrementStep, decrementStep, isLoading, setIsLoading };
};
const WizardStep = ({ stepLabel, stepColor, stepContainerTestId, imageFileName, headerCopy, actionForm, actionText, actionTestId, children, }) => {
    const { currentStep, totalSteps, decrementStep, isLoading } = useWizardFlow();
    return (_jsxs(_Fragment, { children: [_jsxs(Container, Object.assign({ "data-testid": stepContainerTestId }, { children: [imageFileName && _jsx(Image, { filename: imageFileName }), _jsxs(InnerContainer, { children: [_jsx(StyledCopy, Object.assign({ light: true, shouldScaleFont: true, size: "sm", stepColor: stepColor }, { children: stepLabel || `QUESTION ${currentStep} OF ${totalSteps}` })), headerCopy && _jsx(Header, Object.assign({ size: "lg" }, { children: headerCopy })), children] })] })), _jsx(StandardCard.Footer, { isLoading: isLoading, actionDataTestId: actionTestId, actionText: actionText || 'Next', actionForm: actionForm, onBack: currentStep > 1 ? () => decrementStep() : null })] }));
};
export default WizardStep;
//# sourceMappingURL=wizard-flow.js.map